export default __webpack_public_path__ + "static/media/YOMO256.acd5d8e6.png";